import React from 'react';

import SvgIcon from "../../SharedComponents/Icons";

import './index.sass';


const ContractBox = ({ contract, paymentType }) => {

  const {
    accountType,
    features,
    inquiriesIncrease,
    name,
    prices
  } = contract;

  const { discountPrice, price, undiscountedPrice } = prices[paymentType];


  return (
    <div className={`contract-box ${inquiriesIncrease ? ' bordered' : ''}${accountType === 'basic_plus' ? ' main' : ''}`}>

      <div className="contract-box__inquiries-increase-box">
        { inquiriesIncrease && `+${inquiriesIncrease}% flere henvendelser` }
      </div>

      <div className={`contract-box__main-content ${paymentType}`}>
        <div className="contract-box__contract-name">
          { name }
        </div>

        <div className="contract-box__contract-img">
          <SvgIcon name={`contract_${accountType}`} width={1000} height={1000} />
        </div>

        <div className="contract-box__price-block">

          { discountPrice &&
            <div className="contract-box__price-discount">
              { discountPrice }
            </div>
          }

          <div className="contract-box__price">
            { price }
          </div>

          { undiscountedPrice &&
            <div className="contract-box__price-undiscounted">
              { undiscountedPrice }
            </div>
          }

          <a className={`contract-box__link-button cta-button become-advertiser-btn${ accountType === 'basic_plus' ? ' highlighted' : '' }`}
             href={`/signup?account_type=${accountType}&payment_type=${paymentType}`}
             target="_blank" >
            Vælg { name }
          </a>
        </div>

        <div className="contract-box__features">
          { features.map((feature, index) =>
            <div className="contract-box__feature" key={`feature${accountType}${index}`}>
              <SvgIcon name="check" width={22} height={22} />
              <p dangerouslySetInnerHTML={{__html: feature}}></p>
            </div>
          )}
        </div>
      </div>

    </div>
  )
}

export default ContractBox;
